<header *ngIf="bulkStore.selectedEntityType() as selectedEntityType">
  <div
    class="p-3 flex gap-3 p-card surface-ground align-items-center"
    *ngIf="bulkStore.selectedAction() as selectedAction">
    <app-bulk-action-stepper
      [currentActionMenuItem]="getActionByKey(selectedAction)"
      [currentEntityMenuItem]="
        getEntityTypeByKey(selectedEntityType)
      "></app-bulk-action-stepper>
  </div>
</header>
<p-divider></p-divider>
<div class="grid">
  <div class="col-3">
    <p-panelMenu styleClass="w-full" [model]="actionMenu" [multiple]="true" />
  </div>
  <div class="col-9">
    <router-outlet name="aktion"></router-outlet>
  </div>
</div>
